//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: ""
// },

export const streetURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=1gAKAFj2rC2ttpfvo21WdKbh00XT105zJ",
    frame: "Random street shot of a pulses chat seller",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1DMsqbcEwNqeaavCwYmFHJypU4Z40l_pb",
    frame: "Random street shot",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1pNbiVtl6wERxaY6igXrKMYqgF0PY4S0O",
    frame: "One of the best childhood memory of playing cricket on roads",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1dCkkp71JJqTnpypHp_JqJXTj-MEsGswO",
    frame: "Random street shot",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1FsCaFtWaPGAsV5RFlSFCHpC9ROy1LlMw",
    frame: "Scary? that's a puppy toy hanging from a waste dumping truck",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14GDZOgImFt6yVEsoLt90zzwRR8mzWdGh",
    frame: "Light trails in traffic jam, one by one",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1uCu7HB7DyJshheB2e9bEuR4kcyJd6izc",
    frame: "Rural areas in Mumbai",
    location: "Mumbai, Maharashtra, India",
  },

  {
    img:
      "https://drive.google.com/uc?export=view&id=1l_msGCOMZfmO8dcVRwT1p6d8E7gX9Phy",
    frame: "Hard workers",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1R2QEV8mvxW_qiivNgxxnDHI0zNCmKqYs",
    frame: "Random street guy",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1IkWpvPtyNon_V73ttQFWdyYuy7WtdaqZ",
    frame: "Probably a dog lover",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1uYUxPJ-JuwMd_0njZ1lseFcPwem3FpMd",
    frame: "Same dog lover",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=16n9VY4xNVbqYTgmU7pazNlzouD00rEp2",
    frame:
      "Frame in frame of a guy reading newspaper as an early morning schedule",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10TMwESrKaC6kGSL8yAkkJnBtU698eCaV",
    frame: "Random street moment",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1xPFl8KnaZ6tXPQPq1BRif8jcxOD5jQym",
    frame: "Frame in frame",
    location: "Alka talkies chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ivN7zOpMgKa-Y9FMgy7a-eZUNzhWc_e8",
    frame: "Frame in frame of Mahatma phule bai Mandia (vegetable market)",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GZCen97txt7wdn1zw8QOqZYr1-woZTka",
    frame: "Random people in Mahatma phule bai Mandia (vegetable market)",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1rxx-UmwCU8rqsLwwXvYdLuUXsBiV8sdt",
    frame: "Random people in Mahatma phule bai Mandia (vegetable market)",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1cciojh-Qf77VHqv-hcLIxTD6i_yghLUL",
    frame: "Mahatma phule bai Mandia (vegetable market)",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1xhuewmLKyaIfPGJmi7QJY7f9QvCpPM1y",
    frame: "People praying for wishes",
    location: "Dagdu Seth, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1aL5sseN6kHTaJ0H0LB_dyK-0aGfAOam_",
    frame: "An old lady praying in front of Ganesh ji",
    location: "Dagdu Seth, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1bkbGq2GUjyXl9xKt9LcMs-uyGc_-XZdD",
    frame: "Framing of Shani (God) in front of Shaniwar Wada",
    location: "Shaniwar Wada, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1jjfdhaD8zvfk-OgiOG-dLS9Ndx0qAXgU",
    frame: "Just random street shot",
    location: "Dagdu Seth, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GXKlV4ygnjYilQMUI5u-FlSoBXXfcb08",
    frame: "Just random street shot - another angle",
    location: "Dagdu Seth, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10Cigv1OYxp19b4E-lhpNPflo7XK-EfUA",
    frame: "Just random street shot",
    location: "Dagdu Seth, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1_7ECWtXh_41E23M46jMhEq24Hvy_D1Yz",
    frame: "Specially abled random guy - closeup",
    location: "Shaniwar Wada, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1xWPo0hTPacQAg3bPID373wEA909Ze5Eg",
    frame: "Specially abled random guy",
    location: "Shaniwar Wada, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1_oogKpon3LNUche56uBJnzpuHnlQEqFz",
    frame: "Random street guy",
    location: "Shaniwar Wada, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10IRzN8L2-E3tmGIMLsNPOz06paROKO4X",
    frame: "Random street guy",
    location: "Shaniwar Wada, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1nZeN4RrOwiEexXL6Z0AKsh08oTpC55Vm",
    frame: "One more happy candid",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GzQpH__zwqwuScK0dQDMv1gTUMQxLUXL",
    frame: "From inside he was very excited",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1xQxuYaLRBMq3MSGd1ZBjEuIxuM3HyXFe",
    frame: "Such shops and people are rare",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1NkQWC_fwqZSlVjzE3jOXUEIGz_c6K_hE",
    frame: "Winnowing to clean garlic",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Nq9DnTlR_XCHIuudSBab8Lcj0cJH-Nxu",
    frame: "Winnowing to clean garlic",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1aAkaOA5WWrOkFrQ0S7nMQseaExNfaHdz",
    frame: "Some people just demand candid shots",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1_3gC9oRRyO74UAwzqbjTpa_GwPzq42QJ",
    frame: "Happy souls",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Bft5vCjRKFOhn-XPRilDDxLEEgBZc4nk",
    frame: "Candid shot",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1fFh-SRKim_v4nTeBjv3Eo3YBPRqsisZ0",
    frame: "Way more happy no matter what they are doing",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1p6-WTLbTWWs_kkpYCihr8Ca1TKmFSsWQ",
    frame: "Some are heros",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1iW5JPTEOF_8PejODs9XvHkuTHmPVcGty",
    frame:
      "There are few good couples also who ask by themselves for a picture",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=16WOaBA0FZwZDrN2_6OYuogL6HscNfjJi",
    frame: "combination of great people with good talents",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1uzCF5aQn--snSQU455RGpn543paCZu7b",
    frame: "Popcorn seller who blends lots of love within the popcorns",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1q-jnM3dU8OX2Xe5fsQntW-fS6yc2igpP",
    frame: "There is something good in people of Pune",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Expa3znhf92Z9RNRB5uoL3Qc-0B-UJWg",
    frame:
      "Good hooman who gave a free packet of popcorn after taking his portrait",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1SbBy437-9mu1fUzCc8KmKo2l2LGvf1oI",
    frame: "Random guy in pimpri market selling coconut",
    location: "Pimpri market, Pune, Maharashtra, India",
  },
];
